/* unplugin-vue-components disabled */import script from "./OptionalCertificateDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./OptionalCertificateDialog.vue?vue&type=script&setup=true&lang=ts"

import "./OptionalCertificateDialog.vue?vue&type=style&index=0&id=6d4149ba&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d4149ba"]])

export default __exports__